import lozad from 'lozad'

const fn = {
  init: () => {
    const lazyLoader = lozad('[data-lazy]:not([data-loaded])')
    lazyLoader.observe()
  },
}

export default {
  can: () => true,
  run: fn.init,
}
